// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#lt-yantr .zip-code-modal .modal-wrapper{max-width:500px;top:20%}@media (max-width: 767px){#lt-yantr .zip-code-modal .modal-wrapper{top:0}}#lt-yantr .zip-code-modal .form label{font-weight:400;line-height:normal;display:block;margin-bottom:15px}#lt-yantr .zip-code-modal .form input{margin-bottom:10px}#lt-yantr .zip-code-modal .form .btn{margin:10px 0}@media (max-width: 767px){#lt-yantr .zip-code-modal .form .btn{margin-bottom:0}}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
